import { DateTime } from "luxon";
import { I18nNames, NumberishId, NumberRange } from "./type";
import { IdWithName } from "./IdWithName";

export interface Medium {
    readonly id: number;
    readonly primaryPhotoId: string;
    readonly secondaryPhotoIds: Array<string> | null;
    readonly category: {
        readonly id: number;
        readonly name: string;
        readonly selectionColor: string | null;
        readonly iconSvg: string | null;
    };
    readonly kind: MediumKindSummary;
    readonly mediumProvider: IdWithName;
    readonly name: string;
    readonly roads: Array<string> | null;
    readonly address: string | null;
    readonly town: string | null;
    readonly voivodeship: string | null;
    readonly powiat: string | null;
    readonly lat: number | string;
    readonly lng: number | string;
    readonly location: MediumLocationForList | null | undefined;
    readonly direction: MediumDirection;
    readonly height: number | null;
    readonly width: number | null;
    readonly additionalInfo: string | null;
    readonly illuminated: boolean;
    readonly banner: boolean;
    readonly footfall: number | null;
    readonly footfallRange: NumberRange | null;
    readonly addedByEmployee: {
        readonly id: number;
        readonly fullName: string;
    } | null;
    readonly created: DateTime;
    readonly lastConfirmedUpdate: LastConfirmedUpdate | null;
    readonly footfallHidden: boolean;
    readonly mediumCardUrl: string;
    readonly deleted: DateTime | null;
}

export interface LastConfirmedUpdate {
    readonly timestamp: DateTime,
    readonly updatedBy: string
}

export interface MediumAvailability {
    readonly id: number;
    readonly year: number;
    readonly month: number;
    readonly endDay: number;
    readonly startDay: number;
    readonly cost: number;
    readonly price: number;
    readonly accepted: boolean | null;
}

export interface MediumFilterOptions {
    readonly mediumCategories: Array<IdWithName>;
    readonly mediumKinds: Array<IdWithName>;
    readonly voivodeships: Array<string>;
    readonly powiats: Array<string>;
    readonly towns: Array<string>;
}

export interface MediumKindSummary {
    readonly id: number;
    readonly name: string;
    readonly categoryId: number;
    readonly categoryName: string;
    readonly fullName: string;
}

export interface MediumLocation {
    readonly id: number;
    readonly categoryId: number;
    readonly i18nNames: I18nNames;
}

export interface MediumLocationForList {
    readonly id: number;
    readonly name: string;
}

export interface MediumLocationWriteModel {
    readonly categoryId: number;
    readonly i18nNames: I18nNames;
}

export interface MediumLocationCategory {
    readonly id: number;
    readonly i18nNames: I18nNames;
}

export interface MediumLocationCategoryWriteModel {
    readonly i18nNames: I18nNames;
}


export enum MediumDirection {
    UNDEFINED = 'UNDEFINED',
    N = 'N',
    E = 'E',
    W = 'W',
    S = 'S',
    NE = 'NE',
    NW = 'NW',
    SE = 'SE',
    SW = 'SW'
}

//@todo: move to view-tools
export const formatMediumAddress = (medium: BaseMediumGeolocation) => {
    return medium.address
        + (` ${ medium.address || '' } `.indexOf(` ${ medium.town || '' } `) === -1 ? `, ${ medium.town }` : '');
}

export const sortMediumAvailabilities = <T extends AvailabilityPeriod>(availabilities: T[]): T[] => {
    return availabilities.sort((a1, a2) =>
        a1.year * 10000 + a1.month * 100 + a1.startDay > a2.year * 10000 + a2.month * 100 + a2.startDay ? 1 : -1);
}

export const formatMediumAvailabilityPeriod = (a: AvailabilityPeriod): string =>
    `${ String(a.startDay).padStart(2, '0') }-${ String(a.endDay).padStart(2, '0') }.${ String(a.month).padStart(2, '0') }.${ a.year }`

export const formatMediumAvailabilityStartDate = (a: AvailabilityPeriod): string =>
    `${ String(a.startDay).padStart(2, '0') }/${ String(a.month).padStart(2, '0') }/${ a.year }`

export const formatMediumAvailabilityEndDate = (a: AvailabilityPeriod): string =>
    `${ String(a.endDay).padStart(2, '0') }/${ String(a.month).padStart(2, '0') }/${ a.year }`

interface AvailabilityPeriod {
    readonly year: number;
    readonly month: number;
    readonly startDay: number;
    readonly endDay: number;
}

export interface BaseMediumGeolocation {
    readonly town: string | null;
    readonly address: string | null;
}


// export enum MediumSide {
//     A = 'A',
//     B = 'B',
//     C = 'C',
//     D = 'D',
//     E = 'E',
//     F = 'F',
//     G = 'G',
//     H = 'H',
//     I = 'I',
//     J = 'J',
//     _1 = '1',
//     _2 = '2',
//     _3 = '3',
//     _4 = '4',
//     _5 = '5',
//     _6 = '6',
// }